import React, { useEffect, useState } from "react";
import { EVENT } from "../lib/data";

function diff(target) {
  const total = target.getTime() - Date.now();
  const clamp = Math.max(total, 0);
  return {
    days: Math.floor(clamp / 86400000),
    hours: Math.floor((clamp % 86400000) / 3600000),
    minutes: Math.floor((clamp % 3600000) / 60000),
    seconds: Math.floor((clamp % 60000) / 1000),
    done: total <= 0,
  };
}

const Unit = ({ value, label }) => (
  <div className="flex flex-col items-center" data-testid={`countdown-${label.toLowerCase()}`}>
    <div className="relative bg-forest text-cream px-3 md:px-5 py-1 md:py-2 border-2 border-gold shadow-blockgold min-w-[64px] md:min-w-[92px] text-center">
      <span className="numeral text-4xl md:text-6xl leading-none">{String(value).padStart(2, "0")}</span>
    </div>
    <span className="eyebrow text-forest-light mt-2 text-[0.6rem] md:text-xs">{label}</span>
  </div>
);

export const Countdown = () => {
  const [t, setT] = useState(() => diff(EVENT.target));
  useEffect(() => {
    const id = setInterval(() => setT(diff(EVENT.target)), 1000);
    return () => clearInterval(id);
  }, []);

  if (t.done) {
    return (
      <div className="postmark inline-block px-6 py-3 text-lg -rotate-3" data-testid="countdown-live">
        The Festival Is Live!
      </div>
    );
  }

  return (
    <div className="flex items-start justify-center gap-2 md:gap-4" data-testid="countdown-timer">
      <Unit value={t.days} label="Days" />
      <span className="numeral text-4xl md:text-6xl text-gold pt-1 md:pt-2">:</span>
      <Unit value={t.hours} label="Hours" />
      <span className="numeral text-4xl md:text-6xl text-gold pt-1 md:pt-2">:</span>
      <Unit value={t.minutes} label="Mins" />
      <span className="numeral text-4xl md:text-6xl text-gold pt-1 md:pt-2">:</span>
      <Unit value={t.seconds} label="Secs" />
    </div>
  );
};
